import { BLOCKS } from "@contentful/rich-text-types";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { NonWfIngredientsContent } from "@Types/recipes-detail-page";
import { NonWfIngredient } from "./NonWfIngredient";
import classes from "./RecipesDetail.module.scss";

export const NonWfIngredients = (props: NonWfIngredientsContent) => {
  if (!props?.nonWfIngredients?.json) {
    return null;
  }

  return (
    <div className={classes["ingredient-list__content"]}>
      <CmsTextEditorContent
        content={props.nonWfIngredients}
        options={{
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: any, children: any) => {
              return children.map((child: any, index: number) => {
                if (typeof child === "string") {
                  const ingredients = child?.split("\n");

                  return ingredients.map((ingredient, index) => (
                    <NonWfIngredient key={index} ingredient={ingredient} />
                  ));
                }

                return <p key={index}>{child}</p>;
              });
            },
          },
          renderText: (text: string) => text,
        }}
      />
    </div>
  );
};
